<template>
    <div class="ranklist">
        <div class="ranklist_my">
            <van-image round width="1.23rem" height="1.23rem" :src="user.user.avatarurl"></van-image>
            <div class="ranklist_my_info">
                <div class="ranklist_my_info_new">
                    <div class="ranklist_my_info_name">{{user.user.nickname}}</div>
                    <div class="ranklist_my_info_rank" v-if="user.rank>0">排行：第{{user.rank}}名</div>
                </div>
                <!-- <div class="ranklist_my_info_id">
                    ID：wxid53988
                </div>  -->
            </div>
            <div class="ranklist_my_vote">
                <span>{{user.voted}}</span> 票
            </div>
        </div>
        <van-skeleton avatar :row="1" v-if="rankList.length==0"/>
        <van-list
          v-model="loading"
          :finished="finished"
          @load="onLoad"
        >
            <div v-for="(item,key) in front3" :key="key" class="item_ranklist">
                <div class="item_ranklist_info">
                    <van-image width="0.385rem" height="0.49rem" :src="require('@/assets/img/family/'+item.rank+'.png')"></van-image>
                    <div class="item_ranklist_person">
                        <van-image round width="0.71rem" height="0.71rem" :src="item.user.avatarurl"></van-image>
                        <div class="item_ranklist_name">{{item.user.name || item.user.nickname}}</div>
                    </div>
                </div>
                <div class="item_ranklist_rank">{{item.voted+' 票'}}</div>
            </div>
            <div class="item_ranklist" v-for="(item,key) in rankList" :key="item.id" v-if="key>=3">
                <div class="item_ranklist_info">
                    <div class="rank">{{item.rank}}</div>
                    <div class="item_ranklist_person">
                        <van-image round width="0.71rem" height="0.71rem" :src="item.user.avatarurl"></van-image>
                        <div class="item_ranklist_name">{{item.user.name || item.user.nickname}}</div>
                    </div>
                </div>
                <div class="item_ranklist_rank">{{item.voted+' 票'}}</div>
            </div>
        </van-list>

    </div>
</template>
<script>
    import './index.less'
    import { Image, List } from 'vant';
    export default {
        name:"rankList",
        components:{
            vanList:List,
            vanImage:Image
        },
      props: ["itemid"],
        data() {
            return {
                mediaurl: '',
                imgurl:'',
                user:{},
                familyList:[],
                rankList:[],
                front3:[],
                loading: false,
                finished: false,
                page:1
            }
        },
        methods: {
            goDetail:function (val) {
                // console.log(val)
                this.$emit('goDetail',val);
            },
            getFamilyList() {
                this.$api.bainian.getVoteRank({page:this.page,cpgid: this.itemid}).then((res)=>{
                    if(res.status*1===200){
                        this.front3 = []
                        this.rankList = this.rankList.concat(res.data.list)
                        var t=null
                        this.rankList.forEach((item, index) => {
                            if(t == null){
                                t =  item;
                                t.rank = index+1;
                            }else{
                                var n = item;
                                if(n.voted*1 == t.voted*1){
                                    n.rank = t.rank;
                                }else{
                                     n.rank = index+1;
                                }
                                t = n;
                            }
                            if (index < 3) {
                                this.front3.push(Object.assign({}, item));
                            }
                        })
                        if(res.data.page.pageCount*1>this.page){
                            this.page++
                        }else{
                            this.finished   =   true
                        }
                    }
                    this.loading = false;
                })
            },
            onLoad() {
                if(this.finished) return;
                this.getFamilyList();
            },
            init() {
              this.$api.bainian.getMyVote({cpgid: this.itemid}).then((res)=>{
                if(res.status === 200){
                  this.user = res.data
                }
              })
            }
        },
        mounted(){
            this.$nextTick(()=>{
              this.init()
                // this.getFamilyList();
            })
        }
    }
</script>
